import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@morpho-org/ui-v6/client';
import type { BasicCuratorInfo } from '@/components/common/MobileEarnCards/MobileEarnCards.types';
import { RiskCuratorCard } from '@/components/common/RiskCuratorCard';
import { useWeb3Context } from '@/contexts/Web3Context';
export interface MobileCuratorListProps {
  curators: BasicCuratorInfo[];
}
export default function MobileCuratorList(t0) {
  const $ = _c(7);
  const {
    curators
  } = t0;
  const {
    targetChainId
  } = useWeb3Context();
  let t1;
  if ($[0] !== curators || $[1] !== targetChainId) {
    let t2;
    if ($[3] !== targetChainId) {
      t2 = (curator, index) => <RiskCuratorCard key={index} curator={curator} chainId={targetChainId}><div className="gap-2xs flex flex-row items-center">{curator.image && <Avatar src={curator.image} size="small" />}<span className="text-3xs text-foreground" style={{
            lineHeight: "normal"
          }}>{curator.name}</span></div></RiskCuratorCard>;
      $[3] = targetChainId;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = curators.map(t2);
    $[0] = curators;
    $[1] = targetChainId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="gap-xs flex flex-row items-center">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}